import { render } from "./CompetitiveProfile.vue?vue&type=template&id=5e98d29d"
import script from "./CompetitiveProfile.vue?vue&type=script&lang=js"
export * from "./CompetitiveProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__